import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  CardMedia,
  Dialog,
  Divider,
  Grid,
  IconButton,
  LinearProgress,
  Typography,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { ApplicationDownload, getApplicationInvestor } from '../redux-store/actions/onBoarding';
import { ApplicationProps, getInvestorResponseType } from '../redux-store/types/api-types';
import {
  ApproverDocumentUploadOrSendBack,
  FinalDocumentUploadType,
  InvestorUploadDocuement,
  RejectDocuement,
  getApplicationDetails,
  rejectDocumentType,
} from '../redux-store/actions/application';
import { APPLICATION_LISTING_STATUS, APPLICATION_STATUS } from '../utils/constant';
import { ApprovedByAllApplicant, handleDownload } from '../utils/utilityFunctions';
import {
  CommonLayoutForPOA,
  DeclarationUpload,
  LoadingDialog,
  SuccessDialog,
} from './commonComponents';
import { SubHeading } from './investors/components';
import { Formik } from 'formik';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import CloseIcon from '@mui/icons-material/Close';
import { Link as RouterLink } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { MFTextField } from '../lib/formik';
import * as yup from 'yup';
import Comments from './ApplicationDetails/Comments';
import { reportDownload } from './Reports/report-utils';
import ContributorDetails from './ApplicationDetails/contributor';
import ContactDetails from './ApplicationDetails/contactDetails';
import { useSnackbar } from 'notistack';
import { RootStateType } from '../redux-store/reducers';

export const ManualSign = (): JSX.Element => {
  const { id: Id = '', referenceId = '' } = useParams<{ id?: string; referenceId?: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState<FinalDocumentUploadType>({
    signedLeegalityDocumentId: null,
    documentComment: '',
  });
  const [application, setApplication] = useState<ApplicationProps>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sendBackLoading, setSendBackLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [id, setId] = useState('');
  const [documentUpload, setDocumentUpload] = useState(false);
  const rejectInitialValue: rejectDocumentType = { rejectedReason: '' };
  const { applicationId: investorApplicationId } = useSelector(
    (store: RootStateType) => store.investor
  );
  const resonValidation = yup.object().shape({
    rejectedReason: yup.string().required('Please enter the reason for rejection'),
  });
  const initialCommentValues = initialValues;
  const Commentvalidation = yup.object().shape({
    documentComment: yup.string().required('Please provide Comment'),
  });
  const [open, setOpen] = useState(false);
  const [investorSuccess, setInvestorSuccess] = useState(false);
  const [openSendBackDialog, setOpenSendBackDialog] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleSendBack = () => setOpenSendBackDialog(true);
  const handleSendBackClose = () => {
    setOpenSendBackDialog(false);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };
  const handleUpload = () => {
    setDocumentUpload(true);
  };
  const handleUploaded = () => {
    setDocumentUpload(false);
  };
  const onHandleSubmit = async (
    values: FinalDocumentUploadType,
    massageForCheckerSuccess: string
  ) => {
    if (referenceId) {
      const _application = (await dispatch(
        InvestorUploadDocuement(id, values)
      )) as unknown as ApplicationProps;
      setApplication(_application);
      if (ApprovedByAllApplicant(_application.applicants.length, _application.status)) {
        setInvestorSuccess(true);
      }
    } else {
      await dispatch(ApproverDocumentUploadOrSendBack(id, values));
      enqueueSnackbar(massageForCheckerSuccess, {
        variant: 'success',
        autoHideDuration: 3000,
      });
      history.push('/applications-list/document');
    }
  };
  const onSubmit = async (values: FinalDocumentUploadType) => {
    try {
      if (!application?.documentSentBack) {
        setIsSubmitting(true);
        await onHandleSubmit(values, 'Application Approved Successfully');
      } else {
        setInitialValues(values);
        handleSendBack();
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsSubmitting(false);
    }
  };
  const onSendBackSubmit = async (values: FinalDocumentUploadType) => {
    try {
      handleSendBackClose();
      if (referenceId) {
        setIsSubmitting(true);
      } else {
        setSendBackLoading(true);
      }

      await onHandleSubmit(values, 'Application Sent Back Successfully');
    } catch (e) {
      console.error(e);
    } finally {
      setSendBackLoading(false);
      setIsSubmitting(false);
    }
  };

  const onReject = async (values: rejectDocumentType) => {
    try {
      handleClose();
      setRejectLoading(true);
      await dispatch(RejectDocuement(id, values));
      history.push('/applications-list/document');
    } catch (e) {
      console.error(e);
    } finally {
      setRejectLoading(false);
    }
  };

  useEffect(() => {
    (async function () {
      try {
        let applicationId = '';
        if (!Id && referenceId && !investorApplicationId) {
          const Investor = (await dispatch(
            getApplicationInvestor(referenceId)
          )) as unknown as getInvestorResponseType;
          applicationId = Investor.applicationId;
        } else if (investorApplicationId) {
          applicationId = investorApplicationId;
        } else if (Id) {
          applicationId = Id;
        }
        setId(applicationId);
        const _application = (await dispatch(
          getApplicationDetails(applicationId)
        )) as unknown as ApplicationProps;
        setApplication(_application);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
    setLoading(true);
  }, []);
  const isFieldDisabled =
    documentUpload || isSubmitting || sendBackLoading || rejectLoading || loading;
  const [loadingPopup, setLoadingPopup] = useState(false);

  const handleLoadingPopupClose = () => {
    setLoadingPopup(false);
  };
  const DocumentValidation = yup.object().shape({
    signedLeegalityDocumentId: yup.number().nullable().required('Document is required'),
  });
  return (
    <Box sx={{ bgcolor: { xs: '', md: 'rgba(238, 244, 251, 0.5) !important' } }}>
      <CommonLayoutForPOA />
      <Box
        sx={{
          ml: { xs: 0 },
          mt: 10,
          p: { xs: 2, md: '50px' },
          borderRadius: '50px 0 0 0',
          minHeight: window.screen.height - 210,
        }}>
        <SubHeading>
          <Grid container>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {!referenceId && (
                  <IconButton
                    sx={{ height: 'fit-content', p: 0 }}
                    component={RouterLink}
                    to="/applications-list/document"
                    disabled={isFieldDisabled}>
                    <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                  </IconButton>
                )}
                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: 'text.secondary',
                  }}>
                  Individual Investor Onboarding
                </Typography>
              </Box>
              {application?.applicationNumber && (
                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: 'text.secondary',
                  }}>
                  Application ID: {application?.applicationNumber}
                </Typography>
              )}
            </Grid>
          </Grid>
        </SubHeading>
        {application ? (
          <>
            {application?.comments?.length > 0 && (
              <Comments comments={application?.comments} dispalyFormComments={false} />
            )}
            {!referenceId && (
              <>
                <ContributorDetails application={application} />
                <ContactDetails applicants={application.applicants} />
              </>
            )}
            <Grid
              sx={{
                bgcolor: 'white',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
                borderRadius: '10px',
              }}
              mt={5}
              mb={3}>
              <Box sx={{ p: 2 }}>
                <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
                  <Grid
                    container
                    direction="column"
                    justifyContent="space-around"
                    alignItems="center">
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-around"
                      alignItems="flex-start"
                      sx={{
                        button: {
                          color: 'primary.main',
                          px: { sm: 5, xl: 2 },
                          my: 2,
                        },
                      }}>
                      {referenceId && (
                        <LoadingButton
                          loadingPosition="start"
                          variant="outlined"
                          onClick={async () => {
                            try {
                              setLoadingPopup(true);
                              const res = (await dispatch(
                                ApplicationDownload(id)
                              )) as unknown as any;
                              reportDownload(
                                res as unknown as Blob,
                                `${application?.applicationNumber}.pdf`
                              );
                            } catch (e) {
                              console.log(e);
                            } finally {
                              setLoadingPopup(false);
                            }
                          }}
                          disabled={isFieldDisabled}>
                          Download Application Form
                        </LoadingButton>
                      )}
                      {application.signedLeegalityFile?.url && (
                        <LoadingButton
                          loadingPosition="start"
                          variant="outlined"
                          onClick={async () => {
                            try {
                              application?.signedLeegalityFile?.url &&
                                (await handleDownload(
                                  application?.signedLeegalityFile?.url as string,
                                  `${application.applicationNumber}.pdf`
                                ));
                            } catch (e) {
                              console.error((e as Error).message);
                            }
                          }}
                          disabled={isFieldDisabled}>
                          Download Signed Form
                        </LoadingButton>
                      )}
                    </Grid>
                    {(ApprovedByAllApplicant(application.applicants.length, application.status) ||
                      referenceId ||
                      true) && (
                      <>
                        <Box width={'100%'} alignItems={'center'} my={2}>
                          <Divider
                            sx={{
                              borderStyle: 'dashed',
                              borderBottomWidth: 'medium',
                            }}
                          />
                        </Box>
                        <Formik
                          initialValues={initialValues}
                          onSubmit={onSubmit}
                          validationSchema={DocumentValidation}>
                          {({ handleSubmit }) => (
                            <Box
                              width={'100%'}
                              component="form"
                              noValidate
                              onSubmit={handleSubmit}
                              sx={{
                                fontSize: 14,
                                fontWeight: 500,
                                color: 'rgba(0,0,0,0.7)',
                                '.MuiTypography-root': {
                                  fontSize: 15,
                                  fontWeight: 500,
                                },
                              }}>
                              <DeclarationUpload
                                label={'Upload Signed Form'}
                                disabled={false}
                                onFileUpload={handleUpload}
                                onFileUploaded={handleUploaded}
                                documentType={'signedForm'}
                                name={'signedLeegalityDocumentId'}
                              />
                              <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  gap: 1.5,
                                  '.MuiButton-root': {
                                    minWidth: '200px',
                                    maxWidth: '400px',
                                  },
                                }}>
                                {(ApprovedByAllApplicant(
                                  application.applicants.length,
                                  application.status
                                ) ||
                                  (APPLICATION_STATUS.sent_to_applicant1 ===
                                    APPLICATION_STATUS[application.status] &&
                                    referenceId)) && (
                                  <LoadingButton
                                    loadingPosition="start"
                                    variant="contained"
                                    onClick={() => handleSubmit()}
                                    sx={{ color: 'common.white' }}
                                    disabled={isFieldDisabled || sendBackLoading}
                                    loading={isSubmitting}>
                                    Submit
                                  </LoadingButton>
                                )}
                                {!referenceId &&
                                  ApprovedByAllApplicant(
                                    application.applicants.length,
                                    application.status
                                  ) && (
                                    <>
                                      <LoadingButton
                                        loadingPosition="start"
                                        variant="outlined"
                                        onClick={() => handleSendBack()}
                                        sx={{ color: 'primary.main' }}
                                        disabled={isFieldDisabled}
                                        loading={sendBackLoading}>
                                        Send Back
                                      </LoadingButton>
                                      <LoadingButton
                                        loadingPosition="start"
                                        variant="contained"
                                        onClick={() => handleOpen()}
                                        sx={{ color: 'common.white' }}
                                        disabled={isFieldDisabled}
                                        loading={rejectLoading}>
                                        Reject
                                      </LoadingButton>
                                    </>
                                  )}
                              </Grid>
                            </Box>
                          )}
                        </Formik>
                      </>
                    )}
                  </Grid>
                  <Dialog
                    onClose={handleSendBackClose}
                    open={openSendBackDialog}
                    sx={{
                      '.MuiPaper-root ': {
                        p: 4,
                        width: { xs: '70%', sm: '70%' },
                      },
                    }}>
                    <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                    <Box
                      sx={{
                        width: { xs: '100%', sm: '80%' },
                        mx: 'auto',
                        '.MuiTypography-root': {
                          fontSize: 18,
                          fontWeight: 500,
                          textAlign: 'center',
                        },
                      }}>
                      <Typography sx={{ color: 'primary.main' }}>
                        Are you sure you want to{' '}
                        <Typography component="span" sx={{ color: '#BD2932' }}>
                          Send Back
                        </Typography>{' '}
                        the application
                      </Typography>
                      <Typography sx={{ color: '#BD2932', mt: 5 }}>
                        {' '}
                        Give Comments for application Send Back *
                      </Typography>
                      <Formik
                        initialValues={initialCommentValues}
                        onSubmit={(values) => {
                          onSendBackSubmit(values);
                        }}
                        validationSchema={Commentvalidation}>
                        {({ handleSubmit }) => (
                          <Box component="form" noValidate onSubmit={handleSubmit}>
                            <MFTextField
                              name="documentComment"
                              multiline
                              rows={4}
                              placeholder="Type your answer here..."
                            />

                            <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                              <LoadingButton
                                loadingPosition="start"
                                onClick={handleSendBackClose}
                                variant="outlined"
                                sx={{
                                  fontSize: 15,
                                  color: 'primary.main',
                                  minWidth: 180,
                                  letterSpacing: 2,
                                  fontWeight: 500,
                                }}
                                disabled={isFieldDisabled}>
                                Cancel
                              </LoadingButton>
                              <LoadingButton
                                loadingPosition="start"
                                variant="contained"
                                sx={{
                                  fontSize: 15,
                                  minWidth: 180,
                                  letterSpacing: 2,
                                  fontWeight: 400,
                                }}
                                type="submit"
                                loading={isSubmitting || sendBackLoading}>
                                Continue
                              </LoadingButton>
                            </Grid>
                          </Box>
                        )}
                      </Formik>
                    </Box>
                  </Dialog>
                  <Dialog
                    onClose={handleClose}
                    open={open}
                    sx={{
                      '.MuiPaper-root ': {
                        p: 4,
                        width: { xs: '70%', sm: '70%' },
                      },
                    }}>
                    <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                    <Box sx={{ mb: 2 }}>
                      <CardMedia
                        component="img"
                        src="/images/warning-icon-red.svg"
                        sx={{ width: 'unset', mx: 'auto' }}
                      />
                    </Box>
                    <Box
                      sx={{
                        width: { xs: '100%', sm: '80%' },
                        mx: 'auto',
                        '.MuiTypography-root': {
                          fontSize: 18,
                          fontWeight: 500,
                          textAlign: 'center',
                        },
                      }}>
                      <Typography sx={{ color: 'primary.main' }}>
                        Are you sure you want to{' '}
                        <Typography component="span" sx={{ color: '#BD2932' }}>
                          Reject
                        </Typography>{' '}
                        the application
                      </Typography>
                      <Typography sx={{ color: '#BD2932', mt: 5 }}>
                        {' '}
                        Give reason for application rejection *
                      </Typography>
                      <Formik
                        initialValues={rejectInitialValue}
                        onSubmit={onReject}
                        validationSchema={resonValidation}>
                        {({ handleSubmit }) => (
                          <Box component="form" noValidate onSubmit={handleSubmit}>
                            <MFTextField
                              name="rejectedReason"
                              multiline
                              rows={4}
                              placeholder="Type your answer here..."
                            />

                            <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                              <LoadingButton
                                loadingPosition="start"
                                onClick={() => {
                                  handleClose();
                                }}
                                variant="outlined"
                                sx={{
                                  fontSize: 15,
                                  color: 'primary.main',
                                  minWidth: 180,
                                  letterSpacing: 2,
                                  fontWeight: 500,
                                }}
                                disabled={isFieldDisabled}>
                                Cancel
                              </LoadingButton>
                              <LoadingButton
                                loadingPosition="start"
                                variant="contained"
                                sx={{
                                  fontSize: 15,
                                  minWidth: 180,
                                  letterSpacing: 2,
                                  fontWeight: 400,
                                }}
                                type="submit"
                                loading={rejectLoading}>
                                Continue
                              </LoadingButton>
                            </Grid>
                          </Box>
                        )}
                      </Formik>
                    </Box>
                  </Dialog>
                </Grid>
              </Box>
            </Grid>
            <LoadingDialog
              loadingPopup={loadingPopup}
              onLoadingPopupClose={handleLoadingPopupClose}
              loaderText={'Downloading'}
            />
            <SuccessDialog
              message={
                'Your response has been submitted successfully. Our representative will contact you for further process.'
              }
              onClose={() => {
                setInvestorSuccess(false);
              }}
              open={investorSuccess}
              setOpen={() => {
                setInvestorSuccess(false);
                history.push(`application-details`);
              }}
            />
          </>
        ) : (
          <LinearProgress />
        )}
      </Box>
    </Box>
  );
};
